import { render, staticRenderFns } from "./KsButtonDropdownItem.vue?vue&type=template&id=21dfe41e"
import script from "./KsButtonDropdownItem.vue?vue&type=script&lang=js"
export * from "./KsButtonDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports